var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-1 flex-col"},[_c('h2',{staticClass:"font-semibold text-peach mb-4"},[_vm._v("Scanner Profil anlegen")]),_c('ScanerUserForm',{on:{"onButtonClick":() => _vm.$emit('onButtonClick')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }